

/// <reference path="DBDocument.ts" />

// Generated class LegalEntityDocument_ManagedObject

class LegalEntityDocument_ManagedObject extends DBDocument
{
    // Relationship: legalEntity
    set legalEntity(value:LegalEntity) {
        this.setValueForKey(value, 'legalEntity');
    }
    get legalEntity():LegalEntity {
        return this.valueForKey('legalEntity') as LegalEntity;
    }
}
